module.exports = __webpack_public_path__ + "static/office_8-679f7480bd96c83d4a9047e5e98de0a7.jpg";